
<template>
  <section class="wrapper add-new-vehicle">
    <div v-if="state === 'add'">
    <h1>Add New Vehicle</h1>

    <h2 class="tab-heading">Donor Information</h2>
    <div class="tabbed-content">
      <div class="columns">
        <div class="col">
          <chc-input v-model="data.first_name" :error="errors.first_name" label="First Name" :required="true"></chc-input>
          <chc-input v-model="data.last_name" :error="errors.last_name" label="Last Name" :required="true"></chc-input>
          <chc-input v-model="data.caller_name" :error="errors.caller_name" label="Caller Name (if different)"></chc-input>
          <chc-input v-model="data.home_phone" :error="errors.home_phone" label="Home Phone Number"></chc-input>
          <chc-input v-model="data.work_phone" :error="errors.work_phone" label="Work Phone Number"></chc-input>
          <chc-input v-model="data.mobile_phone" :error="errors.mobile_phone" label="Mobile Phone Number"></chc-input>
          <chc-input v-model="data.email" :error="errors.email" label="Email Address"></chc-input>
          <chc-input v-model="data.ssn_tax_id" :error="errors.ssn_tax_id" label="Social Security Number / Tax ID"></chc-input>
          <chc-input v-model="data.year_of_birth" :error="errors.year_of_birth" label="Year of Birth"></chc-input>
          <chc-input v-model="data.charity_id" :error="errors.charity_id" label="Select Charity"
                     :autoCompleteValuesHidden="$store.state.summary.charities"
                     :autoCompleteValues="$store.state.summary.charities_active" format="combo" @input="reloadSources" :required="true"></chc-input>
          <chc-input v-model="data.referral_source_id" :error="errors.referral_source_id" label="Referral Source"
               :loading="isLoadingSources" :disabled="sources.length === 0"
               :autoCompleteValues="sources" format="combo"></chc-input>
        </div>
        <div class="col">
          <h3>Mailing Address</h3>
          <chc-input v-model="data.address_street" :error="errors.address_street" label="Street Address"></chc-input>
          <chc-input v-model="data.address_city" :error="errors.address_city" label="City"></chc-input>
          <chc-input v-model="data.address_state" :error="errors.address_state" label="State" format="combo"
                     :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
          <chc-input v-model="data.address_zip" :error="errors.address_zip" label="Zip" format="zip"></chc-input>
          <chc-checkbox v-model="data.towing_address_different" label="Different Towing Address than Mailing Address"></chc-checkbox>
          <h3 v-if="data.towing_address_different">Towing Address</h3>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_business_name" :error="errors.towing_business_name" label="Business Name"></chc-input>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_contact_name" :error="errors.towing_contact_name" label="Contact Name"></chc-input>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_contact_phone" :error="errors.towing_contact_phone" label="Contact Phone"></chc-input>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_address_street" :error="errors.towing_address_street" label="Street Address"></chc-input>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_address_city" :error="errors.towing_address_city" label="City"></chc-input>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_address_state" :error="errors.towing_address_state" label="State" format="combo"
                     :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
          <chc-input v-if="data.towing_address_different" v-model="data.towing_address_zip" :error="errors.towing_address_zip" label="Zip" format="zip"></chc-input>
        </div>
      </div>
    </div>

    <h2 class="tab-heading">Vehicle Information</h2>
    <div class="tabbed-content">
      <div class="columns">
        <div class="col">
          <chc-input v-model="data.donation_type" :error="errors.donation_type" label="Donation Type" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.donation_type"></chc-input>
          <chc-input v-model="data.vin" :error="errors.vin" label="VIN"
                     @blur="pullVin"></chc-input>
          <chc-input v-model="data.vehicle_year" :error="errors.vehicle_year" :isLoading="loadingVin" label="Vehicle Year" :required="true" ref="vehicleYear"></chc-input>
          <chc-input v-model="data.vehicle_make" :error="errors.vehicle_make" :isLoading="loadingVin" label="Vehicle Make" :required="true" ref="vehicleMake"></chc-input>
          <chc-input v-model="data.vehicle_model" :error="errors.vehicle_model" :isLoading="loadingVin" label="Vehicle Model" :required="true" ref="vehicleModel"></chc-input>
          <chc-input v-model="data.vehicle_color" :error="errors.vehicle_color" label="Color" format="combo"
               :autoCompleteValues="$store.state.constants.vehicle.color" :isLoading="loadingVin" :mustUseAutoCompleteValues="false" ref="vehicleColor"></chc-input>
          <chc-input v-model="data.mileage" :error="errors.mileage" label="Mileage"></chc-input>
          <chc-input v-model="data.drivable" :error="errors.drivable" label="Drivable" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.drivable"></chc-input>
          <chc-input v-model="data.tire_condition" :error="errors.tire_condition" label="Tire Condition" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.tire_condition"></chc-input>
          <chc-input v-model="data.running" :error="errors.running" label="Running" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.running"></chc-input>
          <chc-input v-model="data.transmission_type" :error="errors.transmission_type" label="Transmission Type" format="combo"
                     :isLoading="loadingVin"
                     :autoCompleteValues="$store.state.constants.vehicle.transmission_type" ref="transmissionType"></chc-input>
          <chc-input v-model="data.drive_train" :error="errors.drive_train" label="Drive Train" format="combo"
                     :isLoading="loadingVin"
                     :autoCompleteValues="$store.state.constants.vehicle.drive_train" ref="driveTrain"></chc-input>

          <chc-input v-model="data.battery_and_key_or_keyfob_available" :error="errors.battery_and_key_or_keyfob_available" label="Vehicle's battery works and key or keyfob is available?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.battery_and_key_or_keyfob_available"></chc-input>

          <chc-input v-model="data.all_tires_inflated" :error="errors.all_tires_inflated" label="All tires inflated?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.all_tires_inflated"></chc-input>
          <chc-multiselect-input
            v-if="data.all_tires_inflated === 0"
            placeholder="Location of flat tires"
            fieldLabel="Location of flat tires"
            v-model="data.flat_tires_location"
            track-by="value"
            label="label"
            :options="$store.state.constants.vehicle.flat_tires_location"
            :multiple="true"
            :error="errors.flat_tires_location"
            :allow-empty="false"
            :hide-selected="false"
            :close-on-select="false"
          />

          <chc-input v-model="data.wheels_removed" :error="errors.wheels_removed" label="Vehicle has one or more wheels that are removed?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.wheels_removed"></chc-input>
          <chc-multiselect-input
            v-if="data.wheels_removed === 1"
            placeholder="Location of removed wheels"
            fieldLabel="Location of removed wheels"
            v-model="data.wheels_removed_location"
            track-by="value"
            label="label"
            :error="errors.wheels_removed_location"
            :options="$store.state.constants.vehicle.wheels_removed_location"
            :multiple="true"
            :allow-empty="false"
            :hide-selected="false"
            :close-on-select="false"
          />

          <chc-input v-model="data.body_panels_intact" :error="errors.body_panels_intact" label="Vehicle's body panels are intact?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.body_panels_intact"></chc-input>
          <chc-multiselect-input
            v-if="data.body_panels_intact === 0"
            placeholder="Location of body panel damage"
            fieldLabel="Location of body panel damage"
            v-model="data.body_panels_damage_location"
            track-by="value"
            label="label"
            :options="$store.state.constants.vehicle.body_panels_damage_location"
            :multiple="true"
            :error="errors.body_panels_damage_location"
            :allow-empty="false"
            :hide-selected="false"
            :close-on-select="false"
          />

          <chc-input v-model="data.body_damage_free" :error="errors.body_damage_free" label="Body is free of damage larger than size of baseball?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.body_damage_free"></chc-input>
          <chc-multiselect-input
            v-if="data.body_damage_free === 0"
            placeholder="Location of body damage"
            fieldLabel="Location of body damage"
            v-model="data.body_damage_location"
            track-by="value"
            label="label"
            :options="$store.state.constants.vehicle.body_damage_location"
            :multiple="true"
            :error="errors.body_damage_location"
            :allow-empty="false"
            :hide-selected="false"
            :close-on-select="false"
          />

          <chc-input v-model="data.mirrors_lights_glass_intact" :error="errors.mirrors_lights_glass_intact" label="Vehicle's mirrors, lights, and glass are intact?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.mirrors_lights_glass_intact"></chc-input>
          <chc-multiselect-input
            v-if="data.mirrors_lights_glass_intact === 0"
            placeholder="Location of mirrors, lights, and/or glass damage"
            fieldLabel="Location of mirrors, lights, and/or glass damage"
            v-model="data.mirrors_lights_glass_damage_location"
            track-by="value"
            label="label"
            :options="$store.state.constants.vehicle.mirrors_lights_glass_damage_location"
            :multiple="true"
            :error="errors.mirrors_lights_glass_damage_location"
            :allow-empty="false"
            :hide-selected="false"
            :close-on-select="false"
          />
        </div>
        <div class="col">
          <chc-input v-model="data.mechanical_condition" :error="errors.mechanical_condition" label="Mechanical Condition" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.mechanical_condition"></chc-input>
          <chc-input v-model="data.body_class" :error="errors.body_class" label="Body Class" :isLoading="loadingVin" ref="bodyClass"></chc-input>
          <chc-input v-model="data.doors" :error="errors.doors" label="Number of Doors" format="combo"
                     :isLoading="loadingVin"
                     :autoCompleteValues="$store.state.constants.vehicle.doors" ref="numDoors"></chc-input>
          <chc-input v-model="data.body_condition" :error="errors.body_condition" label="Body Condition" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.body_condition"></chc-input>
          <chc-input v-model="data.rust_condition" :error="errors.rust_condition" label="Rust Condition" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.rust_condition"></chc-input>
          <chc-input v-model="data.paint_condition" :error="errors.paint_condition" label="Paint Condition" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.paint_condition"></chc-input>
          <chc-input v-model="data.interior_condition" :error="errors.interior_condition" label="Interior Condition" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.interior_condition"></chc-input>
          <chc-input v-model="data.missing_parts" :error="errors.missing_parts" label="Missing Parts"></chc-input>
          <chc-input v-model="data.other_conditions" :error="errors.other_conditions" label="Other Conditions"></chc-input>
          <chc-input v-model="data.title_state" :error="errors.title_state" label="Title State" format="combo"
                     :autoCompleteValues="$store.state.constants.us_states_list"></chc-input>
          <chc-input v-model="data.title_status" :error="errors.title_status" label="Title Status" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.title_status"></chc-input>
          <chc-input v-model="data.title_type" :error="errors.title_type" label="Title Type" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.title_type"></chc-input>

          <chc-input v-model="data.interior_intact" :error="errors.interior_intact" label="Interior intact?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.interior_intact"></chc-input>

          <chc-input v-model="data.flood_fire_damage_free" :error="errors.flood_fire_damage_free" label="Vehicle is free of flood or fire damage?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.flood_fire_damage_free"></chc-input>

          <chc-input v-model="data.engine_transmission_condition" :error="errors.engine_transmission_condition" label="Vehicle's engine and transmissions are intact, missing parts or removed?" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.engine_transmission_condition"></chc-input>

          <chc-input v-model="data.usage" :error="errors.usage" label="Vehicle Usage" format="combo"
                     :autoCompleteValues="$store.state.constants.vehicle.usage"></chc-input>
        </div>
      </div>
    </div>

    <p v-if="hasErrors" class="error-message">
      There were errors processing the form. Please fix the fields above.
    </p>

    <div class="field buttons left">
      <input type="submit" @click="submit" class="btn" value="Submit New Vehicle Donation">
      <a class="secondary-action" @click="$router.push({name: 'VehiclesSummary'})">Cancel</a>
    </div>
    </div>

    <div v-if="state === 'success'">
      <h1>Vehicle Successfully Added</h1>
      <a @click="reloadAdd" class="secondary-action">+ Add New Vehicle</a>
    </div>

  </section>
</template>

<script>
import store from '@/store'
import auth from '@/auth'
import VehicleFormMixin from './VehicleFormMixin'

export default {
  name: 'VehicleAdd',
  mixins: [VehicleFormMixin],
  beforeRouteEnter (to, from, next) {
    Promise.all([
      store.dispatch('syncConstants'),
      store.dispatch('syncSummary')
    ]).then(() => {
      next()
    })
  },
  data () {
    return {
      user: auth.user,
      state: 'add',
      data: {
        ssn_tax_id: null,
      },
      errors: {},
      loadingVin: false,
      currentVin: null,
      hasErrors: false,
      isLoadingSources: false,
      sources: [],
    }
  },
  methods: {
    submit () {
      const dataForSubmission = this.cleanVehicleMultiSelectLocationData(this.data)
      store.functions.vehicles.createVehicle(dataForSubmission, (errors) => {
        this.errors = errors
        this.hasErrors = true
      }).then(() => {
        if (this.user.role === 'call') this.state = 'success'
        else this.$router.push({name: 'VehiclesSummary'})
      })
    },
    reloadAdd () {
      this.data = {}
      this.currentVin = null
      this.state = 'add'
    },
    reloadSources (id) {
      if (isNaN(id)) return
      this.isLoadingSources = true
      this.data.referral_source_id = null
      store.functions.charity.getSources(id, (errors) => {
      }).then(response => {
        this.sources = response.data
      }).catch(() => {
      }).finally(() => {
        this.isLoadingSources = false
      })
    },
    pullVin () {
      if (this.data.vin === this.currentVin) return
      this.loadingVin = true
      store.functions.vehicles.vinInfo(this.data, (errors) => {
        this.loadingVin = false
      }).then((response) => {
        this.$refs.vehicleMake.forceUpdateValue(response.data.vehicle_make)
        this.$refs.vehicleModel.forceUpdateValue(response.data.vehicle_model)
        this.$refs.vehicleYear.forceUpdateValue(response.data.vehicle_year)
        this.$refs.vehicleColor.forceUpdateValue(response.data.vehicle_color)
        this.$refs.transmissionType.forceUpdateValue(response.data.transmission_type)
        this.$refs.driveTrain.forceUpdateValue(response.data.drive_train)
        this.$refs.bodyClass.forceUpdateValue(response.data.body_class)
        this.$refs.numDoors.forceUpdateValue(response.data.doors)
        this.currentVin = this.data.vin
        this.loadingVin = false
      }).catch(() => {
        this.$refs.vehicleMake.forceUpdateValue(null)
        this.$refs.vehicleModel.forceUpdateValue(null)
        this.$refs.vehicleYear.forceUpdateValue(null)
        this.$refs.vehicleColor.forceUpdateValue(null)
        this.$refs.transmissionType.forceUpdateValue(null)
        this.$refs.bodyClass.forceUpdateValue(null)
        this.$refs.numDoors.forceUpdateValue(null)
        this.loadingVin = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .col h3:first-child {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehicleAdd.vue